import { createSelector } from '@reduxjs/toolkit';
export const takesFlagsReducer = (state) => state.reduxTakesFlags;
export const takesFlagsDataSelector = createSelector(takesFlagsReducer, (selector) => selector.data);
